import React from 'react';
import style from './recipeModule.css';
import { Card, CardBody, CardText, CardTitle, CardImg, CardImgOverlay } from 'reactstrap';

const Recipe = ({ title, calories, image, ingredients }) => {
    return (
        <div className="col-md-3 col-sm-7 m-2">
            <Card>
                <CardImg width="100%" src={image} />
                <CardBody>
                    <CardTitle>{title}</CardTitle>
                    <CardText>
                        <p> Description
                        <ul>
                                {ingredients.map(ingredient => (
                                    <li>{ingredient.text}</li>
                                ))}
                            </ul>
                        </p>
                    </CardText>
                </CardBody>
            </Card>
        </div>

    );
};

export default Recipe;